module.exports = __webpack_public_path__ + "static/media/Logo.32d75d1e.png";